"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_GIFT_CARD_VALUE_USD = exports.MIN_GIFT_CARD_VALUE_USD = exports.GiftCardStatus = exports.GiftCardType = void 0;
var GiftCardType;
(function (GiftCardType) {
    GiftCardType["TILES"] = "TILES";
    GiftCardType["VALUE"] = "VALUE";
})(GiftCardType = exports.GiftCardType || (exports.GiftCardType = {}));
var GiftCardStatus;
(function (GiftCardStatus) {
    GiftCardStatus["ACTIVE"] = "ACTIVE";
    GiftCardStatus["CANCELLED"] = "CANCELLED";
    GiftCardStatus["SCHEDULED"] = "SCHEDULED";
    GiftCardStatus["REDEEMED"] = "REDEEMED";
})(GiftCardStatus = exports.GiftCardStatus || (exports.GiftCardStatus = {}));
exports.MIN_GIFT_CARD_VALUE_USD = 5;
exports.MAX_GIFT_CARD_VALUE_USD = 1500;
//# sourceMappingURL=giftCards.js.map